// extracted by mini-css-extract-plugin
export default {"container":"ErrorCard_container__RmGH2","button":"ErrorCard_button__mrUrb"};